import Axios from "../axios.js"

/**
 * 支付api
 */
export default {
  /**
   * 支付宝充值
   * @param {String} createId 充值人id，0_可以代表非注册用户
   */
  aliPayRecharge: (targetId, type, amount, createId, success, failure) => {
    Axios.post("/alipay/createRechargeRecord.do", {
      targetId,
      type,
      detailType: "Recharge_AliPay",
      amount,
      createId
    },
      success,
      failure
    )
  },
  /**
   * 微信充值
   * @param {String} createId 充值人id，0_可以代表非注册用户
   * @param {String} payType APP_app支付/JSAPI_微信内授权支付/MWEB_H5支付
   * @param {String} code 微信网页授权获取的code，具体来源请看微信JSAPI支付开发文档，当payType为JSAPI时是必填参数，其他方式可不填
   */
  weixinPayRecharge: (targetId, type, amount, createId, code, payType, success, failure) => {
    Axios.post("/weixinpay/createRechargeRecord.do", {
      targetId,
      type,
      detailType: "Recharge_WeixinPay",
      amount,
      createId,
      code,
      payType
    },
      success,
      failure
    )
  },
  /**
   * 微信sdk配置信息
   */
  getJsApiParameter (url, success, failure) {
    Axios.post("/weixinpay/getJsApiParameter.do", {
      url
    },
      success,
      failure
    )
  },
  /**
   * 现金充值
   * @param {String} password md5加密之后的登录密码，是确保现金支付安全，每次调用之前进行登录用户二次密码验证
   * @param deviceNo 充值虚拟设备号
   * @param conversionRate 金额转电量转换比例
   */
  cashPayRecharge: (targetId, type, amount, password, deviceNo, conversionRate, memo, success, failure) => {
    var formData = new FormData();
    formData.append("targetId", targetId);
    formData.append("type", type);
    formData.append("detailType", "Recharge_CashPay");
    formData.append("amount", amount);
    formData.append("password", password);
    formData.append("deviceNo", deviceNo);
    formData.append("conversionRate", conversionRate);
    formData.append("memo", memo);
    Axios.post("/revenueManagement/rechargeJY1", formData,
      success,
      failure
    )
  },

  /**
   * lxk
   * 充值电量、水量
   * @param {String} password md5加密之后的登录密码，是确保现金支付安全，每次调用之前进行登录用户二次密码验证
   * @param deviceNo 充值电量、水量等到真实设备
   * @param conversionRate 金额转电量转换比例
   */
  powerRecharge: (targetId, type, amount, password, deviceNo, conversionRate, success, failure) => {
    Axios.post("/cashpay/createRechargeWatchRecord.do", {
      targetId,
      type,
      detailType: "Recharge_Watch",
      amount,
      password,
      deviceNo,
      conversionRate
    },
      success,
      failure
    )
  },


  /**
   * 银联支付
   * @param {String} targetId 账户标识,例如对用户就是用户id，对设备就是设备no
   * @param {String} type  Siemens//西门子专用；MeterReading//抄表系统专用
   * @param {String} detailType Recharge_UnionPay
   * @param {Number} amount 充值金额，金额单位为分
   * @param {Number} createId 充值人id，0_可以代表非注册用户
   */
  unionpayRecharge (targetId, type, amount, createId, success, failure) {
    Axios.post("/unionpay/createRechargeRecord.do", {
      targetId,
      type,
      detailType: "Recharge_UnionPay",
      amount,
      createId
    },
      success,
      failure
    )
  }
}
